import { adminTypes } from "@admin/admin-types.di";
import type { AdminRepository } from "@admin/domain/repositories/admin.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import { RecuperableModelError } from "@iot-platform/core";
import type { SpatialLevelResume } from "@station/domain/models/spatial-level-resume.model";
import { inject, injectable } from "inversify";

@injectable()
export class SpatialLevelAddUseCase {
    constructor(
        @inject(adminTypes.repositories.AdminRepository)
        private readonly adminRepository: AdminRepository,
    ) {}

    async execute(
        stationId: string,
        spatialLevelId: string,
    ): Promise<Nullable<SpatialLevelResume>> {
        const addResult = await this.adminRepository.addSpatialLevel(
            stationId,
            spatialLevelId,
        );

        return addResult.match(
            (spatialLevelAdded) => spatialLevelAdded,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return error.instance;
                }

                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
